/*
 *   Copyright (c) 2021 Youra Leangseng
 *   All rights reserved.
 */
import { GetRequest, GetResultObject, GET_NOTIFICATION} from "../../../utils/API";

const TYPES = {
  REQUEST_NOTIFICATION: "REQUEST_NOTIFICATION",
  REQUEST_NOTIFICATION_SUCCESS: "REQUEST_NOTIFICATION_SUCCESS",
  REQUEST_NOTIFICATION_FAILED: "REQUEST_NOTIFICATION_FAILED",
  UPDATE_NOTIFICATION_LIST: "UPDATE_NOTIFICATION_LIST",
};


const getNotification = (params) => {
  return (dispatch) => {
    dispatch({
      type: TYPES.REQUEST_NOTIFICATION,
      payload: {},
    });

    GetRequest(GET_NOTIFICATION, params).then(result=> {

      GetResultObject(result, 'data.content', 200, (datas, {pages, size, total}) => {
        dispatch({
          type: TYPES.REQUEST_NOTIFICATION_SUCCESS,
          payload: {data: datas, pages, size, total},
        });
      })
    })
  }
}

// const updateTicketList = ({data}) => {

//   return (dispatch) => {
//     dispatch({
//       type: TYPES.UPDATE_TICKET_LIST,
//       payload: {data},
//     });
//   }
// }
export default {
  getNotification,
  // updateTicketList,
  TYPES,
};
